/**
 * Accounting Hub text-domain-bound i18n helpers for mission-core modules that originated in
 * accounting-hub.
 *
 * Modules moved from accounting-hub keep their strings on the `accounting-hub` text domain so the
 * rendered/translated output is byte-identical to before the move. The text domain must match the
 * domain registered in PHP; until translation JSON is loaded these return the source string.
 */
import { createI18n } from '@tpct/admin-ui/i18n/createI18n';

export const { __, _x_, _n_, sprintf } = createI18n('accounting-hub');
